<biosimulations-error icon="construction" [pageHasBreadCrumbs]="pageHasBreadCrumbs">
  <ng-container id="message">Under construction</ng-container>
  <ng-container id="details"> This page is under construction. Please check back soon! </ng-container>
</biosimulations-error>
